import React from "react";
import { Context } from "./Context";
import { authState } from "./globalState/authState";

export const StateProvider = ({ children }: any) => {
  const { isLogin, setIsLogin } = authState();
  return (
    <Context.Provider value={{ isLogin, setIsLogin }}>
      {children}
    </Context.Provider>
  );
};
